const initialState = {
    loaded: false,
    activeOverlay: {},
    activeVideo: {
        hotspots: [],
        hotspotDesign: {},
        video: {
            renditionsArray: [],
        },
        subtitles: [],
        timeTriggers: [],
    },
    mainVideo: {},
    endFrameVideo: {},
    videoType: '',
    endFrameEnded: false,
    videoQuality: null,
    id: null,
    uuId: '',
    isFullScreen: false,
    isOverlayClosed: true,
    embedOverlay: false,
    forceSpriteIdShown: false,
    videoRenditions: [],
};

export default initialState;
